import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider, facebookProvider } from '../config/firebase';

/**
 * Sign in with Google using Firebase Authentication
 * @returns {Promise<Object>} User data from Google authentication
 */
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    
    // Extract user information
    const userData = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      provider: 'google'
    };
    
    console.log('Google Sign-In successful:', userData);
    return { success: true, user: userData };
  } catch (error) {
    console.error('Google Sign-In Error:', error);
    
    // Handle specific error codes
    let errorMessage = 'Failed to sign in with Google';
    if (error.code === 'auth/popup-closed-by-user') {
      errorMessage = 'Sign-in popup was closed before completing';
    } else if (error.code === 'auth/cancelled-popup-request') {
      errorMessage = 'Sign-in was cancelled';
    } else if (error.code === 'auth/popup-blocked') {
      errorMessage = 'Sign-in popup was blocked by the browser';
    }
    
    return { success: false, error: errorMessage, code: error.code };
  }
};

/**
 * Sign in with Facebook using Firebase Authentication
 * @returns {Promise<Object>} User data from Facebook authentication
 */
export const signInWithFacebook = async () => {
  try {
    const result = await signInWithPopup(auth, facebookProvider);
    const user = result.user;
    
    // Extract user information
    const userData = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      provider: 'facebook'
    };
    
    console.log('Facebook Sign-In successful:', userData);
    return { success: true, user: userData };
  } catch (error) {
    console.error('Facebook Sign-In Error:', error);
    
    // Handle specific error codes
    let errorMessage = 'Failed to sign in with Facebook';
    if (error.code === 'auth/popup-closed-by-user') {
      errorMessage = 'Sign-in popup was closed before completing';
    } else if (error.code === 'auth/cancelled-popup-request') {
      errorMessage = 'Sign-in was cancelled';
    } else if (error.code === 'auth/popup-blocked') {
      errorMessage = 'Sign-in popup was blocked by the browser';
    } else if (error.code === 'auth/account-exists-with-different-credential') {
      errorMessage = 'An account already exists with this email using a different sign-in method';
    }
    
    return { success: false, error: errorMessage, code: error.code };
  }
};

/**
 * Sign out the current user
 * @returns {Promise<Object>} Sign out result
 */
export const signOut = async () => {
  try {
    await auth.signOut();
    return { success: true };
  } catch (error) {
    console.error('Sign Out Error:', error);
    return { success: false, error: error.message };
  }
};
